import type { PageThemeDefinition } from "../types";

export const designTheme: PageThemeDefinition = {
  id: "design",
  labelKey: "robot.setting.page_theme.design",
  preview: {
    background: "#000000",
    cardBg: "#0E1520",
    text: "#ffffff",
  },
  tokens: {
    background: "#000000",
    cardBg: "#0E1520",
    text: "#ffffff",
    textSecondary: "#D8D8D8",
    border: "#2a2f47",
    headerBg: "#000000",
    inputBg: "#0E1520",
    messageBg: "#0E1520",
    senderBg: "#0E1520",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#4a4a4a",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#151b28",
    accent: "#3B8DEE",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#0E1520",
    chatAgentBubbleBorder: "#2A3A52",
    chatUserGradientStart: "#7E1ED3",
    chatUserGradientEnd: "#480DA7",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#000000",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#F9F9F9",
    chatMediaBg: "#000000",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#3B8DEE",
  },
};
